import { message } from 'antd';
import { useEffect, useMemo, useRef } from 'react';
import { useTranslate } from '@tolgee/react';
import { toUpperCase } from 'utils/toLowerCase';
import { useStore as useStoreList } from 'views/QA/pages/StoreGroup';
import { random } from 'lodash-es';
import { isAuthStatusValid } from 'utils/is';

const useStore = (
  platform: General.CaselessPlatform | undefined,
  region: General.CaselessRegion,
) => {
  const { list: storeList, setList: setStoreList, fetchList: fetchStoreList } = useStoreList();
  const { t } = useTranslate();

  const refsCurrent = {
    fetchStoreList,
    setStoreList,
    t,
  };
  const refs = useRef(refsCurrent);
  refs.current = refsCurrent;

  const store = useMemo(() => {
    if (!storeList) {
      return undefined;
    }
    const authStoreList = storeList.filter(
      (x) =>
        isAuthStatusValid(x.erpAuthStatus) &&
        isAuthStatusValid(x.chatAuthStatus) &&
        !(x.isSip && !x.isPrimarySip),
    );
    return authStoreList[random(authStoreList.length - 1)];
  }, [storeList]);

  useEffect(() => {
    if (!platform) {
      return;
    }

    const upperCasePlatform = toUpperCase(platform);

    const upperCaseRegion = toUpperCase(region);

    const {
      current: { fetchStoreList },
    } = refs;

    fetchStoreList({
      externalType: upperCasePlatform,
      region: upperCaseRegion,
    }).catch(() => {
      const {
        current: { t },
      } = refs;

      message.error(t('phrase.获取店铺列表失败，暂时无法上传图片，请稍后再试'));
    });

    return () => {
      const {
        current: { setStoreList },
      } = refs;

      setStoreList([]);
    };
  }, [platform, region]);

  return store;
};

export default useStore;
